import React, { useRef, useState } from 'react'
import Timer from '../../timer/timer';
import Audio from '../../audio/audio';
import Video from '../../video/video'
import "./carnivalPuzzle.css";
import Modal from 'react-modal';


import styled, { keyframes } from 'styled-components';
import { bounceInUp, fadeIn } from 'react-animations';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: 'none',
        border: 'none',
    },
};

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
Modal.setAppElement('#root');

const Animation = keyframes`${bounceInUp}`;

const FadeInDiv = styled.div`
  animation: 2s ${Animation};
`;


const AnimationSlide = keyframes`${fadeIn}`;

const SlideDownInDiv = styled.div`
  animation: 2s ${AnimationSlide};
`;

const CarnivalPuzzle = (props) => {

    const actorName = "JOE";
    const actorTitle = "Security Guard";
    const playVideo = useRef(null);
    const playAudio = useRef(null);
    const timerRef = useRef(null);

    const input = React.createRef();

    //const posterURL = './actors/JOE.png';

    const posterURL = './bgs/FoodBuildingBG.jpg';

    const congratulateVideoURL = './videos/CNE-09-Solution.mp4';

    const waitingVideoURL = './videos/waitings/Joe_Waiting_FoodBuildingmp4.mp4';

    const promptVideos = ['./videos/4.3CarnivalPuzzlePrompt01.mp4', './videos/4.3CarnivalPuzzlePrompt02.mp4', './videos/4.3CarnivalPuzzlePrompt03.mp4'];

    const [promptIndex, setPromptIndex] = useState(null);

    const [currentVideoURL, setCurrentVideoURL] = useState(null)
    let btnRef = useRef();

    //modal
    const [isBlur, setIsBlur] = useState("blur");

    function showClear(event) {
        event.stopPropagation();
        setIsBlur("");
    }

    const [modalIsOpen, setIsOpen] = useState(false);

    const [gameOverModalIsOpen, setGameOverModalIsOpen] = useState(false);

    function openModal() {
        setIsBlur('blur');
        setIsOpen(true);
    }

    function closeModal() {
        setIsOpen(false);
    }
    function openGameOverModal() {
        setGameOverModalIsOpen(true);
    }

    function closeGameOverModal() {
        timerRef.current(props.initialTimeOut);
        setGameOverModalIsOpen(false);
    }
    function restartGame() {
        setGameOverModalIsOpen(false);
        props.goToStep(null, 'LandingPage');

    }

    //modal end

    const playWaitingVideo = () => {

        setCurrentVideoURL(waitingVideoURL);
        playVideo.current(waitingVideoURL);

    }

    const handleSubmit = (event) => {

        event.preventDefault();

        if (input.current.value.trim().toUpperCase() === "BLITZER" || input.current.value.trim().toLowerCase() === "blitzër") {
            // props.goToStep(null, 'HorseGameIntro');
            if (btnRef.current) {
                btnRef.current.setAttribute("disabled", "disabled");
            }
            playVideo.current(congratulateVideoURL);
            setCurrentVideoURL(congratulateVideoURL);

        } else {
            if (promptIndex === null) {
                setPromptIndex(0);
                playVideo.current(promptVideos[0]);
            } else if (promptIndex === 0) {
                setPromptIndex(1);
                playVideo.current(promptVideos[1]);
            } else if (promptIndex === 1) {
                setPromptIndex(2);
                playVideo.current(promptVideos[2]);
            } else if (promptIndex === 2) {
                setPromptIndex(0);
                playVideo.current(promptVideos[0]);
            } else {
                setPromptIndex(0);
                playVideo.current(promptVideos[0]);
            }

        }

    }
    const gotoFailed = (event, args) => {

        if (gameOverModalIsOpen) {

        } else {
            openGameOverModal();
        }

    }
    const updateVideoStatue = (value, src) => {

        if (value === "ended") {
            if (currentVideoURL === congratulateVideoURL) {
                props.goToStep(null, 'CarnivalGameIntro');
            } else if (waitingVideoURL === currentVideoURL) {
                playWaitingVideo();
            } else if (promptVideos.includes(currentVideoURL)) {
                playWaitingVideo();
            } else {
                playWaitingVideo();
            }

        }

    }
    const updateAudioStatue = (value) => {

    }

    const setUpWarningSound = () => {
        if (playAudio.current) {
            playAudio.current('./musics/30SecondTimer.mp3');
        }
    }
    return (
        <>

            <div className="carnivalPuzzle">
                <div className='carnivalContainer'>
                    <div className='pgTitle'>
                        <div className='gameTitleContainer'>
                            <div className='pgName'>Midway</div>
                            <div className='pgDesc'>Carnival Puzzle</div>
                        </div>
                        <SlideDownInDiv>
                            <div className='hintContainer'>
                                <p>Can you GUESS the secret word?</p>
                            </div>
                        </SlideDownInDiv>
                    </div>

                    <div className='puzzleContent'>
                        <div className='citem1'></div>
                        <div className='citem2'></div>
                        <div className='citem4'></div>
                        <div className='citem3'></div>
                        <div className='citem5'></div>
                        <FadeInDiv>
                            <div className='citem6'></div>
                            <div className='citem8'></div>
                            <div className='Ride1'></div>
                            <div className='Ride4'></div>
                            <div className='Ride2'></div>
                            <div className='Ride3'></div>

                            <div className='Ride5'></div>
                            <div className='Ride6'></div>
                            <div className='Ride7'></div>
                            <div className='Ride8'></div>
                        </FadeInDiv>

                        <div className='citem7'></div>


                    </div>

                </div>

                <div className='videoContainer'>
                    <Timer seconds={props.seconds} gotoFailed={gotoFailed} isReversed={props.isReversed} setUpWarningSound={setUpWarningSound} timerRef={timerRef} updateTimerValue={props.updateTimerValue} />


                    <Video VideoURL="./videos/4_3_Game_Intro_RevisedSep15.mp4" actorName={actorName} actorTitle={actorTitle} poster={posterURL} updateVideoStatue={updateVideoStatue} playVideo={playVideo} />
                    <div className='helpContainer'>
                        <div className='helpButton' onClick={openModal}></div>
                        <Modal
                            isOpen={modalIsOpen}
                            style={customStyles}
                            contentLabel="Food puzzle help"
                        >

                            <div className="helpPopup" onClick={closeModal}>
                                <div className='helpMessageContainer'>
                                    <div className='helpLabel' />
                                    <div className='whitePaperContainer' />
                                    <div className='helpIcon' />
                                    <div className='messageContainter'>
                                        <div className='helpMessage'>
                                            <div className='helpTitle'>Rides, rides, rides!</div>
                                            <div className='helpDesc'>
                                            </div>
                                        </div>
                                        <div className='helpButtonsContainer'>
                                            <button className='revealButton' onClick={showClear} >Click to reveal the clue!</button>
                                            <div className={`blurredClue ${isBlur}`}>
                                                <div>Uhmm... that's a strange word in the poem! </div><div>Does it spell anything else? </div><div>Let's look at the names of the roller coaster rides...</div></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                        <Modal
                            isOpen={gameOverModalIsOpen}
                            style={customStyles}
                            contentLabel="Game over"
                        >

                            <div className="timeOutPopup">
                                <div className='timeoutContainer'>
                                    <div className='timeoutLabel' />
                                    <div className='paperContainer' />
                                    <div className='timeoutPictures'>
                                        <div className='pic1'></div>
                                        <div className='pic2'></div>
                                        <div className='pic3'></div>
                                    </div>
                                    <div className='timeoutMessage'>
                                        Oops you've run out of time!
                                    </div>
                                    <div className='timoutButtonsContainer'>
                                        <button className='timeoutButton' onClick={closeGameOverModal} >Continue?</button>
                                        <button className='timeoutButton' onClick={restartGame}>Restart</button>
                                    </div>
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div>
                        <form onSubmit={handleSubmit}>
                            <div>
                                <label >
                                    <input className="inputField" type="text" placeholder='Type the answer here' ref={input} />
                                </label>
                            </div>
                            <input className="submitButton" type="submit" ref={btnRef} value="Submit" />
                        </form>
                    </div>
                </div>
                <Audio AudioURL="./musics/the-crackdown.mp3" autoPlay loop updateAudioStatue={updateAudioStatue} playAudio={playAudio} />
            </div>
        </>
    );

}

export default CarnivalPuzzle;